// Zoom level after which to stop clustering pins together
export const ClusterZoomLevel = 9;
// Minimum number of pins in a cluster
export const MinimumClusterSize = 10;
// Radius of the cluster. Higher number creates larger clusters at zoomed out levels
export const ClusterRadius = 80;